import { useQuery } from '@tanstack/react-query';
import { BaseQueryOpts } from './baseTypes';
import { checkBillingCard } from '@uplift/api';
import { CalendarDateService } from '@uplift/services';

export const useUserBillingQuery = (userId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'user', userId, 'billing' ],
    queryFn: async () => {
      try {
        const res = await checkBillingCard();

        if (res.error) {
          throw new Error(res.error);
        }

        const expiration = res?.card
          ? CalendarDateService.date()
            .year(res.card.expYear)
            .month(res.card.expMonth - 1)
            .startOf('month')
          : null;

        return {
          ...res.card,
          expiration
        };
      } catch (error) {
        return null;
      }
    },
    ...opts,
  });
};
